import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const VacancyDetail = Loadable({
  loader: () => import("./VacancyDetail"),
  loading: Loading
})
